import React, { FC, Fragment } from 'react';
import { Divider } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import { ClientFollowMapping } from 'api';

import GroupsEdit from './GroupsEdit';
import UsersEdit from './UsersEdit';

interface IPropsEnhanced extends WithStyles<typeof styles> {
  mapping: ClientFollowMapping;
}

const styles = (theme: Theme) =>
  createStyles({
    divider: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
  });

const Company: FC<IPropsEnhanced> = ({ classes, mapping }) => (
  <Fragment>
    <GroupsEdit mapping={mapping} />
    <Divider className={classes.divider} />
    <UsersEdit mapping={mapping} />
  </Fragment>
);

export default withStyles(styles)(Company);
